import type { FC } from "react";
import { OnboardingLayout } from "./OnboardingLayout";
import { OnboardingWizard } from "./OnboardingWizard";

export const OnboardingPage: FC = () => (
  <OnboardingLayout>
    <OnboardingWizard />
  </OnboardingLayout>
);

export { OnboardingLayout } from "./OnboardingLayout";
export { OnboardingWizard } from "./OnboardingWizard";
export default OnboardingPage;
